<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon x-large>perm_identity</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>User Login</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 500px;">
      <v-layout column>
        <v-flex xs12>
          <v-text-field placeholder="Mobile No" outline single-line v-model="login.phone"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            placeholder="Password"
            outline
            type="password"
            single-line
            v-model="login.password"
          ></v-text-field>
        </v-flex>
        <v-flex text-sm-right>
          Forget Password ?
          <a href="#">click here</a>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="blue" @click="onCreateUserClicked">Create Account</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="blue" @click="loginDo">Login</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogm1: "",
      dialog: false,
      login: {
        phone: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapGetters("common", {
      logged: "logged"
    })
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
      this.clearForm();
    },
    clearForm() {
      this.login = {
        phone: "",
        password: ""
      };
    },
    onCreateUserClicked() {
      this.$emit("create");
    },
    loginDo() {
      this.actionButtonClicked = true;
      this.post("/auth", this.login).then(res => {
        if (res.data.success) {
          this.$store.commit("common/setLogged", res.data.data);
          this.$user = this.logged.user;
          this.onCancelled();
        }
        this.snackbarShow(res.data);
        this.actionButtonClicked = false;
      });
    }
  }
};
</script>